import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ScreenType } from '@fgb/core';
@Component({
  selector: 'fgb-games-page',
  templateUrl: './games-page.component.html',
  styleUrl: './games-page.component.scss',
})
export class GamesPageComponent {
  screenType = ScreenType;

  gameCards: any[] = [
    {
      title: 'games.trivia.title',
      description: 'games.trivia.description',
      buttonLabel: 'games.trivia.button',
      route: 'games/trivia',
      image: 'banners/games/quiz-card.jpg',
    },
    {
      title: 'games.polls.title',
      description: 'games.polls.description',
      buttonLabel: 'games.polls.button',
      route: 'games/polls',
      image: 'banners/games/polls-card.jpg',
    },
    {
      title: 'games.predictor.title',
      description: 'games.predictor.description',
      buttonLabel: 'games.predictor.button',
      route: 'games/predictor',
      image: 'banners/games/predictor-card.jpg',
    },
    {
      title: 'games.pickaplayer.title',
      description: 'games.pickaplayer.description',
      buttonLabel: 'games.pickaplayer.button',
      route: 'games/pickaplayer',
      image: 'banners/games/pick-a-player-card.jpg',
    },
  ];

  gameCardsMobile: any[] = [
    {
      title: 'games.trivia.title',
      description: 'games.trivia.description',
      buttonLabel: 'games.trivia.button',
      route: 'games/trivia',
      image: 'banners/games/quiz-card.jpg',
    },
    {
      title: 'games.predictor.title',
      description: 'games.predictor.description',
      buttonLabel: 'games.predictor.button',
      route: 'games/predictor',
      image: 'banners/games/predictor-card.jpg',
    },
    {
      title: 'games.polls.title',
      description: 'games.polls.description',
      buttonLabel: 'games.polls.button',
      route: 'games/polls',
      image: 'banners/games/polls-card.jpg',
    },
    {
      title: 'games.pickaplayer.title',
      description: 'games.pickaplayer.description',
      buttonLabel: 'games.pickaplayer.button',
      route: 'games/pickaplayer',
      image: 'banners/games/pick-a-player-card.jpg',
    },
  ];

  constructor(private router: Router) {}

  navigateByURL(route: string) {
    this.router.navigateByUrl(route);
  }
}
